export default "__VITE_ASSET__b07bffe7__"